/*
  Teströstung „Welcome to the Lab“ (trl-).
  Alle Texte stehen im HTML der Section (Weglot). Dieses Skript blendet nur Varianten ein und aus und schreibt
  Zahlen, Codes, Daten und Beträge in notranslate-Spans (data-n). Der Rezept-Tracker speichert nur im Browser
  (localStorage, erst beim Klick auf „Versuch speichern“).
*/
(function () {
  'use strict';

  var KEY = 'trl-protokoll-v1';

  function init(root) {
    if (root.getAttribute('data-trl-ready')) return;
    root.setAttribute('data-trl-ready', '1');
    var dataEl = root.querySelector('[data-trl-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var LOCALE = document.documentElement.lang || 'de';
    var nf1 = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 });
    var nf0 = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 });
    var dLong = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
    var dShort = new Intl.DateTimeFormat(LOCALE);
    function money(cents) {
      try { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: D.currency || 'EUR' }).format(cents / 100); }
      catch (err) { return (cents / 100).toFixed(2); }
    }

    function q(sel, el) { return (el || root).querySelector(sel); }
    function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
    function show(el, on) { if (el) { el.hidden = !on; } }
    function setN(k, val) { qa('[data-n="' + k + '"]').forEach(function (e) { e.textContent = val; }); }
    function t(k) { var e = q('[data-trl-i18n] [data-t="' + k + '"]'); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function num(s) { var n = parseFloat(String(s == null ? '' : s).replace(',', '.')); return isNaN(n) ? null : n; }
    function has(attr, val) { return (' ' + (attr || '') + ' ').indexOf(' ' + val + ' ') > -1; }
    function variant(sel, attr, val) { qa(sel).forEach(function (e) { show(e, has(e.getAttribute(attr), val)); }); }
    function parseDate(s) { var d = new Date(s + 'T00:00:00'); return isNaN(d.getTime()) ? null : d; }
    function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
    function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }

    /* Espresso-Startwert aus dem Metafeld, z. B. „1:2,5 (z.B. 19gr Kaffee auf 47,5gr Wasser) in 30-35 Sekunden“ */
    var rec = String(D.recipe || '');
    var mR = rec.match(/1\s*:\s*(\d+(?:[.,]\d+)?)/);
    var mD = rec.match(/(\d+(?:[.,]\d+)?)\s*g/i);
    var mT = rec.match(/(\d+)\s*[-–]\s*(\d+)\s*Sek/i);
    var esp = (mR && mD && mT) ? { ratio: num(mR[1]), dose: num(mD[1]), t: mT[1] + '–' + mT[2] } : null;
    var darkRatio = num(D.darkRatio) || 2;
    var darkTime = String(D.darkTime || '25–30');
    var gpl = num(D.filterGpl) || 60;

    var S = {
      step: 1, color: null, shine: null, roastManual: null, method: 'siebtraeger',
      dose: esp ? Math.min(22, Math.max(16, esp.dose)) : 19, cups: 2, taste: null,
      qty: 1, cupsday: 2, gcup: null,
      tri: { codes: null, odd: 0, plan: false, pick: null, rounds: 0, correct: 0 }
    };
    var log = load();
    var dateInput = q('[data-trl-date]');
    var doseInput = q('[data-trl-dose]');
    if (doseInput) { doseInput.value = String(S.dose); }

    function load() {
      try { var raw = window.localStorage.getItem(KEY); var arr = raw ? JSON.parse(raw) : []; return Array.isArray(arr) ? arr : []; }
      catch (err) { return []; }
    }
    function persist() { try { window.localStorage.setItem(KEY, JSON.stringify(log)); } catch (err) { } }

    function roastEst() {
      if (!S.color) return null;
      var lv = { hell: 0, mittel: 1, dunkel: 2 }[S.color];
      if (S.shine === 'oelig' && lv < 2) lv += 1;
      return ['hell', 'mittel', 'dunkel'][lv];
    }
    function roast() { return S.roastManual || roastEst() || 'mittel'; }
    function espVals() {
      if (!esp) return null;
      var dark = roast() === 'dunkel';
      var ratio = dark ? darkRatio : esp.ratio;
      return { ratio: ratio, time: dark ? darkTime : esp.t, yield: S.dose * ratio };
    }
    function filterVals() {
      var coffee = Math.round(gpl * 0.25 * S.cups);
      return { coffee: coffee, water: 250 * S.cups, bloom: coffee * 2, plus: coffee + S.cups };
    }
    function placeholders() {
      var e = espVals();
      var f = filterVals();
      if (S.method === 'siebtraeger' && e) return { dose: nf1.format(S.dose), out: nf1.format(e.yield), time: '' };
      if (S.method === 'handfilter') return { dose: String(f.coffee), out: String(f.water), time: '' };
      if (S.method === 'frenchpress') return { dose: String(f.coffee), out: String(f.water), time: '240' };
      return { dose: '', out: '', time: '' };
    }
    function outKey(m) { return m === 'siebtraeger' ? 'tasse' : ((m === 'handfilter' || m === 'frenchpress') ? 'wasser' : 'menge'); }

    /* Timer */
    var T = { el: null, left: 0, total: 0, run: false, iv: null };
    function fmtT(s) { return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
    function timerUi(el, left, state) {
      var tt = q('[data-trl-timer-t]', el);
      if (tt) tt.textContent = fmtT(left);
      qa('[data-tl]', el).forEach(function (s) { show(s, s.getAttribute('data-tl') === state); });
    }
    function timerStop() { if (T.iv) { clearInterval(T.iv); T.iv = null; } T.run = false; }
    function timerResetAll() {
      timerStop();
      T.el = null; T.left = 0;
      qa('[data-trl-timer]').forEach(function (el) {
        timerUi(el, parseInt(el.getAttribute('data-trl-timer'), 10) || 0, 'start');
        show(q('[data-trl-timer-done]', el), false);
      });
    }
    function timerGo(el) {
      var total = parseInt(el.getAttribute('data-trl-timer'), 10) || 0;
      if (T.el === el && T.run) { timerStop(); timerUi(el, T.left, 'resume'); return; }
      if (T.el !== el || T.left <= 0) { timerResetAll(); T.el = el; T.total = total; T.left = total; }
      show(q('[data-trl-timer-done]', el), false);
      T.run = true;
      timerUi(el, T.left, 'pause');
      T.iv = setInterval(function () {
        T.left -= 1;
        if (T.left <= 0) {
          T.left = 0; timerStop(); timerUi(el, 0, 'start');
          show(q('[data-trl-timer-done]', el), true);
        } else { timerUi(el, T.left, 'pause'); }
      }, 1000);
    }

    /* Protokoll */
    function protoText() {
      return log.map(function (e, i) {
        var p = [];
        if (e.dose) p.push(e.dose + ' ' + t('gkaffee'));
        if (e.out) p.push(e.out + ' ' + t('g' + outKey(e.m)));
        if (e.time) p.push(e.time + ' s');
        if (e.grind) p.push(t('mahlstufe') + ' ' + e.grind);
        var bd = e.bag ? parseDate(e.bag) : null;
        var bag = bd ? t('tuete') + ' ' + dShort.format(bd) : t('ohnedatum');
        return t('versuch') + ' ' + (i + 1) + ' (' + t('m-' + e.m) + ', ' + bag + '): ' + (p.join(' · ') || t('ohnewerte')) +
          (e.taste ? ' · ' + t('t-' + e.taste) : '') + (e.note ? ' · ' + e.note : '') + (e.fav ? ' · ' + t('favorit') : '');
      }).join('\n');
    }
    function renderLog() {
      var box = q('[data-trl-logbox]');
      var list = q('[data-trl-log]');
      var proto = q('[data-trl-proto]');
      if (!box || !list || !proto) return;
      show(box, log.length > 0);
      setN('logcount', String(log.length));
      variant('[data-trl-plural-log]', 'data-trl-plural-log', log.length === 1 ? 'one' : 'many');
      while (list.firstChild) list.removeChild(list.firstChild);
      for (var i = log.length - 1; i >= 0; i--) {
        var e = log[i];
        var li = proto.cloneNode(true);
        li.removeAttribute('data-trl-proto');
        li.setAttribute('data-id', String(e.id));
        q('[data-e="n"]', li).textContent = String(i + 1);
        qa('[data-e-m]', li).forEach(function (s) { show(s, s.getAttribute('data-e-m') === e.m); });
        var bd = e.bag ? parseDate(e.bag) : null;
        qa('[data-e-bag]', li).forEach(function (s) { show(s, s.getAttribute('data-e-bag') === (bd ? 'date' : 'none')); });
        if (bd) q('[data-e="bag"]', li).textContent = dShort.format(bd);
        qa('[data-e-t]', li).forEach(function (s) { show(s, s.getAttribute('data-e-t') === e.taste); });
        ['dose', 'out', 'time', 'grind'].forEach(function (k) {
          show(q('[data-e-p="' + k + '"]', li), !!e[k]);
          q('[data-e="' + k + '"]', li).textContent = e[k] || '';
        });
        show(q('[data-e-p="empty"]', li), !(e.dose || e.out || e.time || e.grind));
        qa('[data-e-o]', li).forEach(function (s) { show(s, s.getAttribute('data-e-o') === outKey(e.m)); });
        q('[data-e="note"]', li).textContent = e.note || '';
        li.classList.toggle('is-fav', !!e.fav);
        var fav = q('[data-e-act="fav"]', li);
        fav.setAttribute('aria-pressed', e.fav ? 'true' : 'false');
        qa('[data-e-fav]', li).forEach(function (s) { show(s, s.getAttribute('data-e-fav') === (e.fav ? 'on' : 'off')); });
        list.appendChild(li);
      }
      show(q('[data-trl-tolab]'), !!q('[data-trl-msg]'));
    }
    function saveEntry() {
      var f = {};
      qa('[data-trl-f]').forEach(function (i) { f[i.getAttribute('data-trl-f')] = i.value.trim(); });
      var ph = placeholders();
      log.push({
        id: Date.now(), m: S.method, dose: f.dose || ph.dose, out: f.out || ph.out, time: f.time || ph.time,
        grind: f.grind || '', note: f.note || '', taste: S.taste, bag: dateInput ? dateInput.value : '', fav: false
      });
      persist();
      qa('[data-trl-f]').forEach(function (i) { i.value = ''; });
      setN('savedno', String(log.length));
      show(q('[data-trl-saved]'), true);
      qa('[data-trl-copied]').forEach(function (s) { show(s, false); });
      renderLog();
    }

    /* Dreieckstest */
    function needed(n) {
      if (n < 1) return null;
      function binom(a, b) { var r = 1; for (var i = 1; i <= b; i++) r = r * (a - b + i) / i; return r; }
      for (var k = 0; k <= n; k++) {
        var p = 0;
        for (var j = k; j <= n; j++) p += binom(n, j) * Math.pow(1 / 3, j) * Math.pow(2 / 3, n - j);
        if (p <= 0.05) return k;
      }
      return null;
    }
    function renderTri() {
      var R = S.tri;
      var active = !!R.codes;
      qa('[data-tri]').forEach(function (el) {
        var k = el.getAttribute('data-tri');
        var on = false;
        if (k === 'intro') on = !active;
        else if (k === 'active') on = active;
        else if (k === 'plan') on = active && R.plan;
        else if (k === 'cups') on = active && !R.plan;
        else if (k === 'ask') on = active && R.pick === null;
        else if (k === 'right') on = active && R.pick !== null && R.pick === R.odd;
        else if (k === 'wrong') on = active && R.pick !== null && R.pick !== R.odd;
        else if (k === 'noscore') on = R.rounds === 0;
        else if (k === 'score') on = R.rounds > 0;
        else if (k === 'few') on = R.rounds < 3;
        else if (k === 'thresh') on = R.rounds >= 3;
        else if (k === 'win') on = R.rounds >= 3 && R.correct >= needed(R.rounds);
        show(el, on);
      });
      if (active) {
        setN('tricodes', R.codes.join(' · '));
        setN('trioddcode', R.codes[R.odd]);
        setN('triround', String(R.rounds + (R.pick === null ? 1 : 0)));
        qa('[data-tri-cup]').forEach(function (b) {
          var i = parseInt(b.getAttribute('data-tri-cup'), 10);
          b.textContent = R.codes[i];
          b.classList.toggle('is-odd', R.pick !== null && i === R.odd);
          b.classList.toggle('is-miss', R.pick !== null && i === R.pick && i !== R.odd);
          b.setAttribute('aria-pressed', R.pick === i ? 'true' : 'false');
        });
      }
      setN('tricorrect', String(R.correct));
      setN('trirounds', String(R.rounds));
      var k2 = needed(R.rounds);
      setN('trineed', k2 === null ? '–' : String(k2));
    }

    /* Hauptdarstellung */
    function render() {
      var r = roast();
      var est = roastEst();
      qa('[data-trl-step]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-trl-step'), 10) === S.step)); });
      qa('[data-trl-panel]').forEach(function (p) { show(p, parseInt(p.getAttribute('data-trl-panel'), 10) === S.step); });
      qa('[data-trl-color]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trl-color') === S.color)); });
      qa('[data-trl-shine]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trl-shine') === S.shine)); });
      qa('[data-trl-method]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trl-method') === S.method)); });
      qa('[data-trl-roast]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trl-roast') === r)); });
      qa('[data-trl-taste]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trl-taste') === S.taste)); });

      show(q('[data-trl-roastbox]'), !!est);
      variant('[data-trl-roastres]', 'data-trl-roastres', est || '');
      variant('[data-trl-roastsrc]', 'data-trl-roastsrc', S.roastManual ? 'manual' : (est ? 'check' : 'none'));
      variant('[data-trl-by-roast]', 'data-trl-by-roast', r);
      variant('[data-trl-recipe]', 'data-trl-recipe', S.method);
      variant('[data-trl-method-label]', 'data-trl-method-label', S.method);

      /* Alter der Bohnen */
      var ageBox = q('[data-trl-agebox]');
      var bd = dateInput && dateInput.value ? parseDate(dateInput.value) : null;
      show(ageBox, !!bd);
      if (bd) {
        var age = Math.round((today().getTime() - bd.getTime()) / 86400000);
        show(q('[data-trl-age="future"]'), age < 0);
        show(q('[data-trl-age="known"]'), age >= 0);
        if (age >= 0) {
          setN('age', String(age));
          variant('[data-trl-plural]', 'data-trl-plural', age === 1 ? 'one' : 'many');
          show(q('[data-trl-age="fresh"]'), age < 5);
          show(q('[data-trl-age="mid"]'), age >= 5 && age < 7);
          show(q('[data-trl-age="ready"]'), age >= 7);
          show(q('[data-trl-age="light"]'), r === 'hell' && age < 10);
        }
      }

      /* Espresso */
      var e = espVals();
      show(q('[data-trl-esp-ok]'), !!e);
      show(q('[data-trl-esp-fail]'), !e);
      if (e) {
        setN('dose', nf1.format(S.dose));
        setN('yield', nf1.format(e.yield));
        setN('esptime', e.time);
        setN('ratio', nf1.format(e.ratio));
        setN('baseratio', nf1.format(esp.ratio));
        setN('basetime', esp.t);
        setN('darkratio', nf1.format(darkRatio));
        setN('darktime', darkTime);
        setN('shortyield', nf1.format(S.dose * darkRatio));
      }

      /* Filter und French Press */
      var f = filterVals();
      setN('cups', String(S.cups));
      setN('fcoffee', String(f.coffee));
      setN('fwater', String(f.water));
      setN('fbloom', String(f.bloom));
      setN('fcoffeeplus', String(f.plus));
      setN('gpl', nf0.format(gpl));
      var temps = D.temps || {};
      setN('ftemp', String(temps[r] != null ? temps[r] : ''));

      /* Diagnose */
      show(q('[data-trl-advicebox]'), !!S.taste);
      variant('[data-trl-advice]', 'data-trl-advice', S.taste || '');
      qa('[data-trl-for]').forEach(function (p) {
        var ok = has(p.getAttribute('data-trl-for'), S.method);
        var cond = p.getAttribute('data-trl-if');
        if (ok && cond && e) ok = cond === (e.ratio > darkRatio ? 'long' : 'short');
        else if (ok && cond && !e) ok = cond === 'short';
        show(p, ok);
      });
      show(q('[data-trl-rule]'), S.taste && S.taste !== 'lecker');

      /* Formular-Platzhalter (nur Zahlen) */
      variant('[data-trl-outlabel]', 'data-trl-outlabel', outKey(S.method));
      var ph = placeholders();
      ['dose', 'out', 'time'].forEach(function (k) { var i = q('[data-trl-f="' + k + '"]'); if (i) i.placeholder = ph[k]; });

      /* Kaufen */
      setN('qty', String(S.qty));
      var total = (D.price || 0) * S.qty;
      setN('total', money(total));
      if (D.freeShip != null) {
        var rest = D.freeShip - total;
        show(q('[data-trl-ship="rest"]'), rest > 0);
        show(q('[data-trl-ship="free"]'), rest <= 0);
        show(q('[data-trl-ship="two"]'), rest > 0 && S.qty === 1 && (D.price || 0) * 2 >= D.freeShip);
        if (rest > 0) setN('shiprest', money(rest));
      }

      /* Kaffee-Wecker */
      var gDef = { siebtraeger: Math.round(S.dose), vollautomat: num(D.vaGram) || 10, handfilter: Math.round(gpl * 0.25), frenchpress: Math.round(gpl * 0.25), bialetti: Math.round(gpl * 0.25) }[S.method];
      var g = S.gcup || gDef;
      var days = Math.max(1, Math.floor(1000 / (S.cupsday * g)));
      var end = addDays(today(), days);
      var remind = addDays(end, -4);
      if (remind.getTime() <= today().getTime()) remind = addDays(today(), 1);
      setN('cupsday', String(S.cupsday));
      setN('gcup', String(g));
      setN('days', String(days));
      setN('enddate', dLong.format(end));
      setN('reminddate', dLong.format(remind));
      var ics = q('[data-trl-ics]');
      if (ics) {
        var ymd = function (d) { return String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0'); };
        var esc = function (s) { return String(s).replace(/([,;\\])/g, '\\$1'); };
        var body = [
          'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//19grams//Testroestung//DE', 'BEGIN:VEVENT',
          'UID:trl-' + ymd(remind) + '-' + Date.now() + '@19grams.coffee',
          'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''),
          'DTSTART;VALUE=DATE:' + ymd(remind), 'DTEND;VALUE=DATE:' + ymd(addDays(remind, 1)),
          'SUMMARY:' + esc(t('ics-summary')),
          'DESCRIPTION:' + esc(t('ics-text') + ' ' + (D.productUrl || '')),
          'END:VEVENT', 'END:VCALENDAR'
        ].join('\r\n');
        ics.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(body));
      }

      renderTri();
    }

    /* Klicks */
    root.addEventListener('click', function (ev) {
      var el = ev.target.closest('button, a, summary');
      if (!el || !root.contains(el)) return;
      var a;
      if ((a = el.getAttribute('data-trl-step'))) { S.step = parseInt(a, 10); render(); return; }
      if ((a = el.getAttribute('data-trl-goto'))) {
        S.step = parseInt(a, 10); render();
        var top = q('#trl-protokoll') || root;
        top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if ((a = el.getAttribute('data-trl-color'))) { S.color = a; S.roastManual = null; render(); return; }
      if ((a = el.getAttribute('data-trl-shine'))) { S.shine = a; S.roastManual = null; render(); return; }
      if ((a = el.getAttribute('data-trl-roast'))) { S.roastManual = a; render(); return; }
      if ((a = el.getAttribute('data-trl-method'))) { S.method = a; S.gcup = null; timerResetAll(); render(); return; }
      if ((a = el.getAttribute('data-trl-taste'))) { S.taste = a; render(); return; }
      if ((a = el.getAttribute('data-trl-inc'))) {
        var dir = parseInt(el.getAttribute('data-dir'), 10) || 0;
        var lim = { cups: [1, 4], qty: [1, 5], cupsday: [1, 8], gcup: [5, 25] }[a];
        if (a === 'gcup') {
          var cur = S.gcup || parseInt((q('[data-n="gcup"]') || {}).textContent, 10) || 10;
          S.gcup = Math.min(lim[1], Math.max(lim[0], cur + dir));
        } else if (lim) {
          S[a] = Math.min(lim[1], Math.max(lim[0], S[a] + dir));
        }
        render();
        return;
      }
      if (el.hasAttribute('data-trl-timer-go')) { timerGo(el.closest('[data-trl-timer]')); return; }
      if (el.hasAttribute('data-trl-timer-reset')) { timerResetAll(); return; }
      if (el.hasAttribute('data-trl-save')) { saveEntry(); return; }
      if ((a = el.getAttribute('data-e-act'))) {
        var li = el.closest('[data-id]');
        var id = li ? Number(li.getAttribute('data-id')) : null;
        if (a === 'fav') log = log.map(function (x) { if (x.id === id) { x.fav = !x.fav; } return x; });
        if (a === 'del') log = log.filter(function (x) { return x.id !== id; });
        persist(); show(q('[data-trl-saved]'), false); renderLog();
        return;
      }
      if (el.hasAttribute('data-trl-copy')) {
        var txt = t('title') + '\n' + protoText();
        var done = function (ok) { qa('[data-trl-copied]').forEach(function (s) { show(s, s.getAttribute('data-trl-copied') === (ok ? 'ok' : 'fail')); }); };
        try { navigator.clipboard.writeText(txt).then(function () { done(true); }, function () { done(false); }); } catch (err) { done(false); }
        return;
      }
      if (el.hasAttribute('data-trl-tolab')) {
        var msg = q('[data-trl-msg]');
        if (msg) { msg.value = t('meinprotokoll') + '\n' + protoText() + '\n\n' + t('meinefrage') + ' '; }
        return;
      }
      if (el.hasAttribute('data-trl-clear')) { show(el, false); show(q('[data-trl-confirm]'), true); return; }
      if (el.hasAttribute('data-trl-clear-no')) { show(q('[data-trl-clear]'), true); show(q('[data-trl-confirm]'), false); return; }
      if (el.hasAttribute('data-trl-clear-yes')) {
        log = []; persist();
        show(q('[data-trl-clear]'), true); show(q('[data-trl-confirm]'), false); show(q('[data-trl-saved]'), false);
        qa('[data-trl-copied]').forEach(function (s) { show(s, false); });
        renderLog();
        return;
      }
      if (el.hasAttribute('data-tri-new')) {
        var codes = [];
        while (codes.length < 3) { var c = String(100 + Math.floor(Math.random() * 900)); if (codes.indexOf(c) < 0) codes.push(c); }
        S.tri.codes = codes; S.tri.odd = Math.floor(Math.random() * 3); S.tri.plan = true; S.tri.pick = null;
        renderTri();
        return;
      }
      if (el.hasAttribute('data-tri-hide')) { S.tri.plan = false; renderTri(); return; }
      if (el.hasAttribute('data-tri-cup')) {
        if (!S.tri.codes || S.tri.plan || S.tri.pick !== null) return;
        var pick = parseInt(el.getAttribute('data-tri-cup'), 10);
        S.tri.pick = pick; S.tri.rounds += 1; if (pick === S.tri.odd) S.tri.correct += 1;
        renderTri();
        return;
      }
      if (el.hasAttribute('data-tri-reset')) { S.tri = { codes: null, odd: 0, plan: false, pick: null, rounds: 0, correct: 0 }; renderTri(); return; }
      if (el.hasAttribute('data-trl-ref')) { var src = q('[data-trl-sources]'); if (src) src.open = true; return; }
      if (el.hasAttribute('data-trl-add')) {
        if (el.getAttribute('aria-disabled') === 'true') return;
        el.setAttribute('aria-disabled', 'true');
        qa('[data-add]', el).forEach(function (s) { show(s, s.getAttribute('data-add') === 'busy'); });
        fetch(D.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: D.variantId, quantity: S.qty }] })
        }).then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.json();
        }).then(function () {
          window.location.href = D.cartUrl;
        }).catch(function () {
          el.removeAttribute('aria-disabled');
          qa('[data-add]', el).forEach(function (s) { show(s, s.getAttribute('data-add') === 'idle'); });
          show(q('[data-trl-add-fail]'), true);
          setTimeout(function () { window.location.href = D.productUrl; }, 1800);
        });
      }
    });

    if (doseInput) {
      doseInput.addEventListener('input', function () { S.dose = num(doseInput.value) || S.dose; render(); });
    }
    if (dateInput) {
      dateInput.addEventListener('change', render);
      dateInput.addEventListener('input', render);
    }

    timerResetAll();
    render();
    renderLog();
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-trl-root]')).forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
